import { z } from "zod";
import { AddressPayloadSchema, AddressSchema } from "../address/address.types.js";
// Base schema for common team member fields
const BaseTeamMemberSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().email(),
    isActive: z.boolean(),
    address: AddressSchema,
    invitedAt: z.coerce.date(),
    invitationAcceptedAt: z.coerce.date().nullable(),
});
// Manager schema - no permission fields needed (full access)
export const ManagerSchema = BaseTeamMemberSchema.extend({
    role: z.literal("manager"),
});
// Worker schema - includes permission fields
export const WorkerSchema = BaseTeamMemberSchema.extend({
    role: z.literal("worker"),
    canCreateInvoice: z.boolean(),
    canEditCustomer: z.boolean(),
});
// Union type for team members (can be either manager or worker)
export const TeamMemberSchema = z.discriminatedUnion("role", [ManagerSchema, WorkerSchema]);
export const CreateManagerPayloadSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().email(),
    address: AddressPayloadSchema.optional(),
});
export const UpdateManagerPayloadSchema = z
    .object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    email: z.string().email().optional(),
    address: AddressPayloadSchema.optional(),
})
    .partial();
export const CreateWorkerPayloadSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().email(),
    address: AddressPayloadSchema.optional(),
    canCreateInvoice: z.boolean().default(false),
    canEditCustomer: z.boolean().default(false),
});
export const UpdateWorkerPayloadSchema = z
    .object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    email: z.string().email().optional(),
    address: AddressPayloadSchema.optional(),
    canCreateInvoice: z.boolean().optional(),
    canEditCustomer: z.boolean().optional(),
})
    .partial();
//# sourceMappingURL=team.types.js.map